import React from 'react';

import classes from './CommonWrapper.scss'

const commonWrapper = (props) => (
    <div className={`${classes.Wrapper} pt-5 pb-5 pl-8 pr-8 phone-pl-3 phone-pr-3 u-backgroundColorWhite u-flex f-row`}>
        {props.children}
    </div>
);

export default commonWrapper;


// WEBPACK FOOTER //
// ./src/components/Addons/Common/CommonWrapper/CommonWrapper.js